import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './pages.css';
import projectDescriptions from '../data/projectDescriptions';

const BlogPost = () => {
  const { title } = useParams();
  const navigate = useNavigate();
  const decodedTitle = decodeURIComponent(title);
  
  const getDescription = (title) => {
    return projectDescriptions[title] || 
      `Detailed information about "${title}" will be coming soon.`;
  };

  const description = getDescription(decodedTitle);

  const goBack = () => {
    navigate('/blogs');
  };

  return (
    <div className="page-container">
      <div className="blog-post-page">
        <button className="back-button" onClick={goBack}>
          ← Back to Blogs
        </button>
        
        <div className="blog-post-content">
          <h1 className="blog-post-title">{decodedTitle}</h1>
          
          <div className="blog-post-body" dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
    </div>
  );
};

export default BlogPost;
